/**
 *
 * Format Local URL
 *
 * @returns
 */

export const formatLocalhostUrl = () => {
  let url = document.body.getAttribute('data-base-url');

  return url.replace('en/', '');
};

/**
 * Return Empty Search Message
 */

export const returnEmptySearchMsg = () => {
  const searchMessage = document.getElementById("search-message-section");
  if (getSearchParam() && searchMessage) {
    const url = formatLocalhostUrl(),
      container = searchMessage.querySelector(".container"),
      title = container.querySelector("h1"),
      message = '<p class="lead">Non ci sono risultati per la tua ricerca.</p>' + '<p class="lead">Effettua una nuova ricerca o torna alla <a class="text-link" href="' + url + '">Home Page</a>.</p>';
    title.insertAdjacentHTML("afterend", message);
  }
};

/**
 * Get Search param from URL
 *
 * @returns
 */

export const getSearchParam = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("s");
};

/**
 * Init Google Map
 */

export const initMap = () => {};

/**
 * Formatta info evento in Cart
 *
 * @param {*} variationSlot
 */

export const formatEventDateTime = (variationSlot) => {
  variationSlot.forEach(function (value) {
    let slot = value.children[0].innerHTML,
      dateTime = slot.split(" "),
      formattedDate = formatDateTimeSlot(dateTime[0]),
      url = formatLocalhostUrl(),
      path = "/wp-content/themes/biglietteria-theme-2024/assets/img/";
    value.children[0].remove();
    let services = '<div class="chekout-service-row d-flex text-1">';
    services += '<img src="' + url + path + 'icon-date.svg" alt="Data" title="Data" width="15" height="19" loading="lazy">';
    services += formattedDate + "</div>";
    services += '<div class="chekout-service-row d-flex text-1">';
    services += '<img src="' + url + path + 'icon-time-grey.svg" alt="Orario" title="Orario" width="15" height="19" loading="lazy">';
    services += dateTime[1] + "</div>";
    value.innerHTML = services;
  });
};

/**
 * Formatta Data in Woocommerce Checkout
 *
 * @param {*} value
 * @returns
 */

export const formatDateTimeSlot = (value) => {
  if (value != "<img") {
    const lang = document.documentElement.getAttribute("lang");
    let reggie = /(\d{4})-(\d{2})-(\d{2})/,
      [, year, month, day] = reggie.exec(value),
      date = new Date(year, month - 1, day),
      options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      },

      formattedDate = date.toLocaleDateString(lang, options);
    return formattedDate;
  } else return "";
};
